<template>
  <div class="content-layout">
    <div class="number-content">1</div>
    <div class="content">
      <div class="content-left">
        2021/11/22 <br/><span>一棟マンション/JR京浜東北線/東京/1LDK</span>
      </div>
      <div class="content-right">
        <div class="custom-control custom-switch left">
          <input type="checkbox" class="custom-control-input" id="customSwitch1"/>
          <label class="custom-control-label" for="customSwitch1">新着メールを受け取る</label>
        </div>
        <button class="btn-search">該当物件を検索</button>
        <br/>
        <button class="btn-remove">該当物件を検索</button>
      </div>
    </div>
  </div>
  <div class="content-layout">
    <div class="number-content">2</div>
    <div class="content">
      <div class="content-left">
        2021/11/22 <br/><span
      >一棟マンション/JR京浜東北線/東京/1LDK一棟マンション/JR京浜東北線/東京/1LDK一棟マンション/JR京浜東北線/東京/1LDK一棟マンション/JR京浜東北線/東京/1LDK一棟マンション/JR京浜東北線/東京/1LDK一棟マンション/JR京浜東北線/東京/1LDK一棟マンション/JR京浜東北線/東京/1LDK一棟マンション/JR京浜東北線/東京/1LDK一棟マンション/JR京浜東北線/東京/1LDK一棟マンション/JR京浜東北線/東京/1LDK</span
      >
      </div>
      <div class="content-right">
        <div class="custom-control custom-switch left">
          <input type="checkbox" class="custom-control-input" id="customSwitch2"/>
          <label class="custom-control-label" for="customSwitch2">新着メールを受け取らない</label>
        </div>
        <button class="btn-search">該当物件を検索</button>
        <br/>
        <button class="btn-remove">該当物件を検索</button>
      </div>
    </div>
  </div>
  <div class="content-layout">
    <div class="number-content">3</div>
    <div class="content">
      <div class="content-left">
        2021/11/22 <br/><span>一棟マンション/JR京浜東北線/東京/1LDK</span>
      </div>
      <div class="content-right">
        <div class="custom-control custom-switch left">
          <input type="checkbox" class="custom-control-input" id="customSwitch3"/>
          <label class="custom-control-label" for="customSwitch3">新着メールを受け取る</label>
        </div>
        <button class="btn-search">該当物件を検索</button>
        <br/>
        <button class="btn-remove">該当物件を検索</button>
      </div>
    </div>
  </div>
  <div class="content-layout">
    <div class="number-content">4</div>
    <div class="content">
      <div class="content-left">
        2021/11/22 <br/><span
      >一棟マンション/JR京浜東北線/東京/1LDK一棟マンション/JR京浜東北線/東京/1LDK一棟マンション/JR京浜東北線/東京/1LDK一棟マンション/JR京浜東北線/東京/1LDK一棟マンション/JR京浜東北線/東京/1LDK一棟マンション/JR京浜東北線/東京/1LDK一棟マンション/JR京浜東北線/東京/1LDK一棟マンション/JR京浜東北線/東京/1LDK一棟マンション/JR京浜東北線/東京/1LDK一棟マンション/JR京浜東北線/東京/1LDK</span
      >
      </div>
      <div class="content-right">
        <div class="custom-control custom-switch left">
          <input type="checkbox" class="custom-control-input" id="customSwitch4"/>
          <label class="custom-control-label" for="customSwitch4">新着メールを受け取る</label>
        </div>
        <button class="btn-search">該当物件を検索</button>
        <br/>
        <button class="btn-remove">該当物件を検索</button>
      </div>
    </div>
  </div>
</template>
